import React from "react"
import {FieldManagementFormProps} from "../../../render/management-form";
import FieldManagementFormProto from "../../../proto/render/management/management-form";
import FormManager from "../../../../gd-form/common/form-manager";

export default class FieldColor_ManagementForm extends FieldManagementFormProto {

    constructor(props:FieldManagementFormProps) {
        super(props);

        // important to have it here !
        this.formStructure.onSubmit = this.onSubmit;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit = (result:any) => {
        super.onSubmit(result);

        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field);
    }

}